<script>
import { getShortDateDisplay, getDateValue, createOneSpankBank, readAllSpankBankMemories, updateOneSpankBank, deleteOneSpankBank } from '@/services/SpankBankServices';
export default {
  data() {
    return {
      uId: localStorage.getItem('uId'),
      token: localStorage.getItem('idToken'),
      loading: true,
      // dbase
      allSpankBank: null,
      // add new SpankBank
      accordionNewSpank: null,
      newSpankText: '',
      newSpankTrigger: '',
      todaysDate: {}, // { display: 'Thu, Jun 25', value: '2026-06-25'

      // MODAL - detail one spankbank
      showSpankDetailModal: false,
      detailSpankId: '',
      detailSpankText: '',
      detailSpankTrigger: '',
      detailSpankDates: [],
      // MODAL - edit a spankbank
      showEditSpankModal: false,
      editSpankId: '',
      editSpankText: '',
      editSpankTrigger: '',
      editSpankDates: [],
      // MODAL - confirm delete a spankbank
      showConfirmDeleteOne: false,
    };
  },
  computed: {
    sbIds() {
      return this.allSpankBank ? Object.keys(this.allSpankBank) : [];
    },
    canAddNewSpank() {
      return this.newSpankText.trim().length > 0;
    },
    canEditSpank() {
      return this.editSpankText.trim().length > 0;
    },
  },
  methods: {
    async addNewSpankMemory() {
      // console.log('*** starting addNewSpankMemory ***');

      let newSpankBankMemory = {
        spank: this.newSpankText,
        bonerDates: [ this.todaysDate ],
      };
      if (this.newSpankTrigger.trim().length > 0) newSpankBankMemory.trigger = this.newSpankTrigger.trim();

      const successfullyCreatedNewSpankBank = await createOneSpankBank(this.uId, this.token, newSpankBankMemory);
      if (successfullyCreatedNewSpankBank) {
        // add new cheatMeal to the UI
        // console.log('*** successfullyCreatedNewSpankBank ***', successfullyCreatedNewSpankBank);
        if (!this.allSpankBank) this.allSpankBank = {};
        this.allSpankBank[successfullyCreatedNewSpankBank.name] = newSpankBankMemory;
        // clean up the fields
        this.newSpankText = '';
        this.newSpankTrigger = '';
      }

    },

    async imHardAgain(spankId) {
      // console.log('*** starting imHardAgain(spankId) ***', spankId);

      let newSpank = { ...this.allSpankBank[spankId] };
      newSpank.bonerDates = [ this.todaysDate, ...this.allSpankBank[spankId].bonerDates ];

      const successfullyUpdatedSpankBank = await updateOneSpankBank(this.uId, this.token, spankId, newSpank);
      if (successfullyUpdatedSpankBank) {
        // console.log('*** imHardAgain() >> response from api ***', successfullyUpdatedSpankBank);
        this.allSpankBank[spankId] = newSpank;
      }

    },

    showOneSpankBankDetail(spankId) {
      console.log('*** start showOneSpankBankDetail() ***', spankId);
      this.detailSpankId = spankId;
      this.detailSpankText = this.allSpankBank[spankId].spank;
      this.detailSpankTrigger = this.allSpankBank[spankId].trigger;
      this.detailSpankDates = [ ...this.allSpankBank[spankId].bonerDates ];
      this.showSpankDetailModal = true;
    },
    async closeOneSpankBankDetail() {
      // console.log('*** start closeOneSpankBankDetail() ***');

      this.showSpankDetailModal = false;
      await this.$nextTick();
      this.detailSpankId = this.detailSpankText = this.detailSpankTrigger = '';
      this.detailSpankDates = [];
    },

    showTheEditSpankModal(spankId) {
      // console.log('*** start showTheEditSpankModal(spankId) ***', spankId);
      this.editSpankId = spankId;
      this.editSpankText = this.allSpankBank[spankId].spank;
      this.editSpankTrigger = this.allSpankBank[spankId].trigger;
      this.editSpankDates = [ ...this.allSpankBank[spankId].bonerDates ];

      this.showSpankDetailModal = false;

      this.showEditSpankModal = true;
    },

    removeEditSpankDate(dateIndex) {
      // console.log('*** start removeEditSpankDate(dateIndex) ***', dateIndex, this.editSpankDates);

      this.editSpankDates.splice(dateIndex, 1);
    },

    async cancelEditSpank() {
      // console.log('*** start cancelEditSpank() ***');

      this.editSpankId = this.editSpankText = this.editSpankTrigger = '';
      this.editSpankDates = [];
      await this.$nextTick();
      this.showEditSpankModal = false;

    },

    async saveEditSpank() {
      // form updated SpankBank object
      let s = {
        spank: this.editSpankText.trim(),
      };
      if (this.editSpankTrigger.trim().length > 0) s.trigger = this.editSpankTrigger.trim();
      if (this.editSpankDates.length > 0) s.bonerDates = [ ...this.editSpankDates ];
      // console.log('*** start saveEditSpank() ***', this.editSpankId, s);

      // API call
      const successfullyUpdatedASpankBank = await updateOneSpankBank(this.uId, this.token, this.editSpankId, s);
      if (successfullyUpdatedASpankBank) {
        // console.log('*** successfullyUpdatedASpankBank ***', successfullyUpdatedASpankBank);
        // update this.allSpankBank
        this.allSpankBank[this.editSpankId] = successfullyUpdatedASpankBank;

        // reset edit vars
        // hide modal
        await this.cancelEditSpank();
      }
    },
    
    async deleteSpank() {
      // console.log('*** start deleteSpank() ***', this.editSpankId);

      await deleteOneSpankBank(this.uId, this.token, this.editSpankId);
      this.showEditSpankModal = false;
      window.location.reload();
    },

  },
  async created() {
    console.clear();

    // set this.todaysDate {display,value}
    const today = new Date();
    this.todaysDate = {
      display: getShortDateDisplay(today),
      value: getDateValue(today),
    };

    // get this.allSpankBank
    this.allSpankBank = await readAllSpankBankMemories(this.uId, this.token);
    this.loading = false;
    console.log('*** created >> got allSpankBank ***', this.allSpankBank);


    if (!this.allSpankBank) {
      this.accordionNewSpank = 0;
    }
  },
}
</script>

<template>
<div id="page-spank-bank">

  <!-- PAGE HEADING -->
  <div class="mt-6 mb-2 d-flex justify-space-between align-center">
    <h1>Spank Bank</h1>
    <p class="me-1"><i>{{todaysDate.display}}</i></p>
  </div>

  <!-- INTRO BLURB -->
  <div class="mx-2 mb-6">
    <p class="mb-1 text-body-2">A mental collection of sexual fantasies, memories, or attractive people that a person stores in their memory to use later #fap</p>
    <p class="mb-1 text-body-2">When you see fap inspiration, make a deposit to your SpankBank for later.</p>
  </div>

  <!-- ADD A SPANK MEMORY -->
  <v-expansion-panels v-model="accordionNewSpank">
    <v-expansion-panel class="px-1">
      <v-expansion-panel-title class="bg-red-lighten-2 font-weight-bold text-capitalize">+ make a deposit to your SpankBank</v-expansion-panel-title>
      <v-expansion-panel-text class="pt-4 pb-2 px-1">
        <v-textarea v-model="newSpankText"
                    label="Describe your fantasy"
                    placeholder="e.g. mini-skirt secretary"
                    variant="outlined"
                    density="comfortable"
                    rows="2"
                    auto-grow
                    clearable
        ></v-textarea>
        <v-textarea v-model="newSpankTrigger"
                    label="What triggered this boner?"
                    placeholder="e.g. there was a hot secretary at the office"
                    variant="outlined"
                    density="comfortable"
                    rows="2"
                    auto-grow
                    clearable
        ></v-textarea>

        <div class="d-flex justify-space-between align-end">
          <p class="text-body-2"><i>{{ todaysDate.value}}</i></p>
          <v-btn @click.prevent="addNewSpankMemory"
                 class="text-grey-darken-3"
                 :color="canAddNewSpank ? 'green-lighten-2' : 'grey-lighten-2'"
                 :disabled="!canAddNewSpank"
          >Add</v-btn>
        </div>
      </v-expansion-panel-text>
    </v-expansion-panel>
  </v-expansion-panels>

  <div v-if="loading" class="text-center mt-5 pt-5">
    <v-progress-circular :size="100" color="amber" width="8" indeterminate></v-progress-circular>
  </div>


  <!-- CARDS - SpankBank Memories -->
  <div v-if="!loading && allSpankBank" id="all-spank-bank-cards"
       class="my-12 d-flex justify-space-between flex-wrap"
  >
    <v-card v-for="id in sbIds" :key="id"
            class="card-one-spank-bank-boner px-2 pt-2 pb-4 d-flex flex-column justify-space-between border"
            border="lg" elevation="16"
    >
      <!-- boner name -->
      <h3 class="boner-title mb-4 allow-new-line text-center font-weight-bold">
        {{ allSpankBank[id].spank }}
      </h3>

      <!-- Boner Button - to open detail modal -->
      <div class="px-1 d-flex justify-center">
        <v-btn @click.prevent="showOneSpankBankDetail(id)"
               color="green-lighten-2"
               size="large"
               class="text-white font-italic"
        >BONER</v-btn>
      </div>

    </v-card>
  </div> <!-- end cards for allCheatMeals -->


  <!-- MODAL: VIEW DETAIL - ONE SpankBank Deposit -->
  <v-dialog v-model="showSpankDetailModal" fullscreen>
    <v-card>
      <v-toolbar>
        <v-btn @click.prevent="closeOneSpankBankDetail"
               icon="mdi-close"
        ></v-btn>
        <h2>Close Spank Bank Detail</h2>
      </v-toolbar>

      <div id="modal-detail-boner-content" class="pa-4 bg-yellow-lighten-5 h-100">
        <div id="modal-detail-boner-max-width-container">

          <h2 class="allow-new-line">{{ detailSpankText }}</h2>

          <!-- i'm hard again -->
          <div class="mt-8 mb-10 d-flex justify-center">
            <v-btn @click.prevent="imHardAgain(detailSpankId)"
                   variant="outlined"
                   density="comfortable"
                   color="red-lighten-1"
                   class="px-2 text-capitalize"
            >I'm Aroused Again</v-btn>
          </div>

          <!-- triggers -->
          <div v-if="detailSpankTrigger.length">
            <p class="mt-8 mb-2"><b><u>Triggers</u></b></p>
            <p class="allow-new-line mb-4 text-grey-darken-1">
              {{ detailSpankTrigger }}
            </p>
          </div>

          <!-- bonerDates -->
          <p class="mt-12 mb-2"><b><u>Dates of Boners</u></b></p>
          <ol class="ms-8 mb-4">
            <li v-for="d in detailSpankDates" :key="d.value" class="mb-2">
              <i>{{ d.display }}</i>
            </li>
          </ol>

          <div class="mt-16 d-flex justify-center">
            <v-btn @click.prevent="showTheEditSpankModal(detailSpankId)"
                   variant="text"
                   density="compact"
                   color="red-lighten-2"
                   class="text-body-2 text-lowercase font-italic"
            >edit this boner</v-btn>
          </div>


          <!-- CLOSE -->
          <div class="mt-8 d-flex flex-column align-center">
            <v-btn @click.prevent="closeOneSpankBankDetail"
                   color="grey-darken-2"
                   variant="outlined"
                   density="comfortable"
                   class="mt-8 px-2"
            >Close Details</v-btn>
          </div> <!-- end CLOSE -->

        </div>
      </div>
    </v-card>
  </v-dialog>


  <!-- MODAL: EDIT ONE SpankBank Deposit -->
  <v-dialog v-model="showEditSpankModal" fullscreen>
    <v-card>
      <v-toolbar>
        <v-btn @click.prevent="showEditSpankModal = false"
               icon="mdi-close"
        ></v-btn>
        <h2>Edit Spank Bank Deposit</h2>
      </v-toolbar>

      <div id="modal-edit-boner-content" class="pa-4 bg-yellow-lighten-5 h-100">
        <div id="modal-edit-boner-max-width-container">

          <!-- EDIT -->
          <h3 class="mb-2">SpankBank Deposit</h3>
          <v-textarea v-model="editSpankText"
                      label="What You Saw"
                      placeholder="e.g. mini-skirt secretary"
                      variant="outlined"
                      density="comfortable"
                      rows="2"
                      auto-grow
                      clearable
          ></v-textarea>

          <h3 class="mb-2">Why It was Bonerific</h3>
          <v-textarea v-model="editSpankTrigger"
                      label="What triggered this boner?"
                      placeholder="e.g. there was a hot secretary at the office"
                      variant="outlined"
                      density="comfortable"
                      rows="2"
                      auto-grow
                      clearable
          ></v-textarea>

          <h3 class="mb-2">Dates of Boners</h3>
          <ul class="ms-8">
            <li v-for="(date, i) of editSpankDates" :key="i">
              <div class="d-flex">
                <p class="ps-2 pb-2">{{ date.display }}</p>
                <v-btn @click.prevent="removeEditSpankDate(i)"
                       color="red-lighten-2"
                       variant="text"
                       density="compact"
                       class="text-body-2 font-italic"
                >delete</v-btn>
              </div>
            </li>
          </ul>

          <!-- SAVE / CANCEL -->
          <div class="my-12 d-flex flex-column align-center">
            <h3 class="mb-3 font-italic">Does everything look accurate?</h3>
            <v-btn @click.prevent="saveEditSpank"
                   :disabled="!canEditSpank"
                   :color="canEditSpank ? 'green-lighten-1' : 'grey-lighten-1'"
                   class="border"
            >Confirm & Save Boner</v-btn>
            <v-btn @click.prevent="cancelEditSpank"
                   color="red-lighten-2"
                   density="comfortable"
                   class="mt-8 px-2"
            >Cancel</v-btn>
            <div class="my-16 pt-8">
              <v-btn @click="showConfirmDeleteOne = true"
                     variant="outlined"
                     color="red-lighten-2"
                     density="compact"
                     class="text-lowercase font-italic"
              >Delete this SpankBank Boner</v-btn>
            </div>
          </div> <!-- end SAVE/CANCEL -->

        </div>
      </div>
    </v-card>
  </v-dialog>


  <!-- MODAL: CONFIRM > DELETE ONE SpankBank Deposit -->
  <v-dialog v-model="showConfirmDeleteOne">
    <v-card>
      <v-toolbar>
        <v-btn @click.prevent="showConfirmDeleteOne = false"
               icon="mdi-close"
        ></v-btn>
        <h2>Really Delete this SpankBank Deposit?</h2>
      </v-toolbar>

      <div class="px-4 py-8">
        <h4>Do you <i>really</i> want to delete this SpankBank Deposit?</h4>

        <div class="mt-8 d-flex justify-space-between align-center">
          <v-btn @click.prevent="showConfirmDeleteOne = false"
                 color="grey-darken-2"
                 variant="outlined"
                 density="compact"
                 class="text-capitalize"
          >Cancel</v-btn>
          <v-btn @click.prevent="deleteSpank"
                 color="red-lighten-1"
                 class="text-capitalize"
          >Delete Forreal</v-btn>
        </div>
      </div>
    </v-card>
  </v-dialog>

</div>
</template>

<style scoped lang="scss">
.allow-new-line { white-space: pre-line; }
#page-spank-bank {
  max-width: 700px;
  margin: 0 auto;
  padding: 0 8px;

  #all-spank-bank-cards {
    max-width: 650px;
    margin-left: auto;
    margin-right: auto;

    .card-one-spank-bank-boner {
      width: 45%;
      margin: 12px 8px;
      min-height: 220px;
    }

  }

}
#modal-edit-boner-content {
  #modal-edit-boner-max-width-container {
    max-width: 700px;
    margin: 0 auto;
  }
}
</style>
